export enum SSOProviders {
  Google = 'google',
  Slack = 'slack',
  Apple = 'apple',
  OpenId = 'openId',
}
